<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <v-btn
          v-if="$auth.loggedIn"
          icon
          color="amber"
          class="align-self-center"
          :loading="loading"
          @click.native.stop="toggleFavorites()"
        >
          <v-icon v-if="isFavClone">mdi-star</v-icon>
          <v-icon v-else>mdi-star-outline</v-icon>
        </v-btn>
      </div>
    </template>
    <span v-if="isFavClone">Already Added to Favorite</span>
    <span v-else>Add to Favorite</span>
  </v-tooltip>
</template>
<script>
import { mapActions } from 'vuex'
// import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'FavoriteBtn',
  props: {
    marketId: { type: [String, Number], default: '', required: true },
    favorite: { type: Object, default: () => {}, required: false },
    isFavorite: { type: Boolean, default: false, required: true }
  },
  data() {
    return {
      isFavClone: false,
      loading: false
    }
  },
  watch: {
    favorite() {
      this.isFavClone = JSON.parse(localStorage.getItem('favorites'))?.find(
        (item) => item?.marketId === this.favorite?.id
      )
    }
  },
  created() {
    if (
      localStorage.getItem('favorites') &&
      Array.isArray(JSON.parse(localStorage.getItem('favorites')))
    ) {
      this.isFavClone = JSON.parse(localStorage.getItem('favorites'))?.find(
        (item) => item?.marketId === this.favorite?.id
      )
    }
  },
  methods: {
    ...mapActions({
      toggle: 'favorites/toggle'
    }),
    async toggleFavorites() {
      // console.log('favorite in toggle favorites', this.favorite)
      this.isFavClone = !this.isFavClone
      this.loading = true
      await this.toggle({
        marketId: this.favorite.id,
        groupById: this.favorite.groupById,
        status: this.isFavClone
      })
      this.loading = false
      const text = this.isFavClone
        ? 'Added to favorites'
        : 'Removed from favorites'
      this.$store.commit('snackbar/open', {
        text,
        color: 'success'
      })
    }
  }
}
</script>
<style scoped>
.v-toolbar__content .v-btn.v-btn--icon.v-size--default,
.v-toolbar__extension .v-btn.v-btn--icon.v-size--default {
  height: auto;
  width: auto;
  padding: 0 0.2rem;
}
.v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:last-child,
.v-application--is-ltr .v-toolbar__extension > .v-btn.v-btn--icon:last-child {
  margin: 0 !important;
}
</style>
